module.exports = __webpack_public_path__ + "img/google-play.7b63e03c.png";